import React, { useEffect, useState } from 'react';
import { Alert, Badge, Card, Spinner, Table } from 'react-bootstrap';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase/firebase';
import NavbarGlobal from './NavbarGlobal';

const formatearFecha = (fecha) => {
  if (!fecha) return 'Pendiente de sincronizar';
  const date = typeof fecha.toDate === 'function' ? fecha.toDate() : new Date(fecha);
  return Number.isNaN(date.getTime()) ? 'Pendiente de sincronizar' : date.toLocaleString('es-CO', { dateStyle: 'medium', timeStyle: 'short' });
};

const RegistroLog = () => {
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const cargarRegistros = async () => {
      try {
        const functions = getFunctions(app, 'us-central1');
        const obtenerRegistroErroresEjercicios = httpsCallable(functions, 'obtenerRegistroErroresEjercicios');
        const resultado = await obtenerRegistroErroresEjercicios();
        setRegistros(resultado.data?.registros || []);
      } catch (err) {
        console.error('Error al cargar el registro de errores:', err);
        setError('No se pudo cargar el registro de errores. Inténtalo nuevamente.');
      } finally {
        setCargando(false);
      }
    };

    cargarRegistros();
  }, []);

  return (
    <div>
      <NavbarGlobal title="Registro de errores de ejercicios" showBackButton />
      <main className="container py-4">
        <Card className="shadow-sm">
          <Card.Body>
            <Card.Title>Fallos de envío reportados por alumnos</Card.Title>
            <Card.Text className="text-muted">
              Se registran los errores de guardado sin incluir el contenido de las respuestas.
            </Card.Text>
            {error && <Alert variant="danger">{error}</Alert>}
            {cargando ? (
              <div className="text-center py-5"><Spinner animation="border" /> <span className="ms-2">Cargando registros...</span></div>
            ) : !error && registros.length === 0 ? (
              <Alert variant="info" className="mb-0">Aún no hay errores registrados.</Alert>
            ) : !error && (
              <div className="table-responsive">
                <Table striped hover size="sm" className="align-middle mb-0">
                  <thead>
                    <tr><th>Fecha</th><th>Alumno</th><th>Lectura / ejercicio</th><th>Nivel y módulo</th><th>Detalle técnico</th><th>Ruta</th></tr>
                  </thead>
                  <tbody>
                    {registros.map((registro) => (
                      <tr key={registro.id}>
                        <td>{formatearFecha(registro.creadoEn)}</td>
                        <td><div>{registro.correoAlumno}</div>{registro.nombreAlumno && <small className="text-muted">{registro.nombreAlumno}</small>}</td>
                        <td><strong>{registro.lectura || registro.ejercicio || 'No identificado'}</strong>{registro.lectura && registro.ejercicio && <div><small>{registro.ejercicio}</small></div>}</td>
                        <td><Badge bg="secondary">{registro.nivel || 'Sin nivel'}</Badge><div className="mt-1">Módulo {registro.modulo || 'N/D'}</div></td>
                        <td><code>{registro.codigo || 'sin código'}</code><div><small>{registro.mensaje}</small></div></td>
                        <td><small>{registro.ruta || 'N/D'}</small></td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Card.Body>
        </Card>
      </main>
    </div>
  );
};

export default RegistroLog;
